<template>
  <el-container class="SaleStatementSelect">
    <el-main>
      <ATable
        ref="table"
        :data="items"
        max-height="500px"
        hide-top-panel
        hide-pagination
        hideButtonInsert
        hideButtonExcel
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column 
          type="selection" 
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목"
          width="250"
          show-overflow-tooltip
        />
        <el-table-column 
          label="규격" 
          prop="size" 
          :width="$width.size"
          show-overflow-tooltip 
        />
        <el-table-column
          prop="amount"
          label="수량"
          class-name="cell-number"
          :width="$width.amount"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="field"
          label="현장"
          show-overflow-tooltip
        />
        <el-table-column
          prop="desc"
          label="비고"
          show-overflow-tooltip
        />
      </ATable>
    </el-main>
    <el-footer>
			<el-button
        type="primary"
        v-shortkey="['f8']"
        :disabled="selection.length < 1"
        @shortkey.native="handleClickPrint"
        @click="handleClickPrint"
      >{{$t('button.print')}} (F8)</el-button>
      <el-button @click="handleClickClose" class="right">{{$t('button.close')}}(Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>
export default {
	name: "SaleStatementSelect",
  data() {
    return {
      selection: [],
    }
  },
  props: {
    data: {
      type: Array,
      required: true
    },
  },
  computed: {
    items() {
      let items = [];
      this.data.forEach(c => {
        c.details.forEach(d => {
          items.push({
            customer_name: c.customer_name,
            contract_date: c.contract_date,
            id: d.id,
            size: d.size,
            amount: d.amount,
            field: d.field,
            desc: d.desc,
            statement_flag: "Y",
            product_name: d.product_name,
          });
        });
      });
      return items;
    },
  },
  mounted() {
    this.$refs.table.toggleRowSelection(this.items, true);
  },
  methods: { 
		handleIndex(index) {
      return this.$refs.table.indexResolver(index);
		},
		handleClickPrint() {
      let ids = this.selection.map(s => s.id);
      let selectedData = this.util.clone(this.data);
      selectedData.forEach(c => {
        let details = c.details.filter(d => ids.includes(d.id));
        c.details = details;
      })
      this.$emit('completed', selectedData);
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickClose() {
      this.$emit('completed');
    },
  }
}
</script>